import Achievements from "../../components/achievements/Achievements";
import CountriesReach from "../../components/countries/CountriesReach";
import Swiper from "../../components/swiper/Swiper";
import WhatPeopleSay from "../../components/whatPeopleSay/WhatPeopleSay";

const Home = () => {

  return (
    <div className="min-h-screen">
      <Swiper />
      <Achievements />
      <CountriesReach />
      <WhatPeopleSay />
    </div>
  );
};

export default Home;
